export const queryKeys = {
    LOGIN: 'login',
    USER: 'user',
    COMPANIES: 'companies',
    EMPLOYEES: 'employees',
    MY_CONTACTS: 'contacts',
    SINGLE_COMPANY: 'company',
    TEAMS: 'teams',
    FILTERS: 'filters',
};
